import NuntLP from './NuntLP';
import LP01 from './LP01';
import PrivacyPolicy from './PrivacyPolicy';
import Contact from './Contact';
import Download from './Download';
import NuntLP02 from './pages/lp02/NuntLP02';
import Apply from './pages/lp02/Apply';
import ApplyThanks from './pages/lp02/ApplyThanks';
import { LANG_ATTR } from './utils/lang';

function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';

  // LP01 / LP02 は言語対応外（先にマッチさせる）
  if (path === '/lp01') return <LP01 />;
  if (path === '/lp02') return <NuntLP02 />;
  if (path === '/lp02/apply') return <Apply />;
  if (path === '/lp02/apply/thanks') return <ApplyThanks />;

  // パスから言語を判定
  let lang = 'th';
  if (path.startsWith('/en')) lang = 'en';
  else if (path.startsWith('/jp')) lang = 'jp';

  // 言語プレフィックスを除いたベースパス
  const basePath = path.replace(/^\/(en|jp)/, '') || '/';

  // lang属性を切り替え
  document.documentElement.lang = LANG_ATTR[lang];

  // /（タイ語トップ）へのアクセス時：ブラウザ言語 or localStorage 設定で振り分け
  // 無限ループ防止：basePath が '/' かつ lang が 'th'（言語未指定）の場合のみ実行
  if (basePath === '/' && lang === 'th') {
    let target = null;
    try {
      const saved = localStorage.getItem('nunt_lang');
      if (saved === 'en') {
        target = '/en';
      } else if (saved === 'jp') {
        target = '/jp';
      } else if (!saved) {
        const nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
        if (nav.startsWith('ja')) target = '/jp';
        else if (!nav.startsWith('th')) target = '/en';
      }
    } catch (_) {}
    if (target) {
      window.location.replace(target);
      return null;
    }
  }

  // 多言語ルーティング
  if (basePath === '/privacy') return <PrivacyPolicy language={lang} />;
  if (basePath === '/contact') return <Contact language={lang} />;
  if (basePath === '/download') return <Download language={lang} />;
  return <NuntLP language={lang} />;
}

export default App;
